import { Container } from "@mui/material";
import { Box } from "~/components/ui/box";
import { MapControl } from "~/components/ui/map";
import { Stack } from "~/components/ui/stack";
import { Text } from "~/components/ui/text";
import { tsr } from "~/utils/client";

export const AvailabilityMapSummaryOverlay = () => {
  const { data } = tsr.reporting.getAvailabilitySummary.useQuery({
    queryKey: ["reporting", "availability", "summary"],
    refetchInterval: 60000, // 1 minute
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
  });

  const summary = data?.body;

  if (!summary) {
    return null;
  }

  return (
    <MapControl position={google.maps.ControlPosition.BOTTOM_LEFT}>
      <Box
        display="flex"
        zIndex={100000000}
        align="center"
        sx={{
          background: "rgba(0, 0, 0, 0.7)",
          marginLeft: "-76px",
          width: "100vw",
          minHeight: "8vh",
        }}
      >
        <Container maxWidth="md">
          <Stack
            direction="row"
            gap={{ xs: "small", md: "xxlarge" }}
            justify="space-around"
            paddingX={{ xs: "small", sm: "xlarge" }}
            paddingY={{ xs: "xxlarge", sm: "xlarge" }}
            sx={{
              width: "100%",
            }}
          >
            <SummaryItem
              value={summary.activeRequestsCount}
              label="Active Requests"
            />
            <SummaryItem
              value={summary.activatedMembersCount}
              label="Activated Members"
            />
            <SummaryItem
              value={summary.availableMembersCount}
              label="Available Members"
            />
          </Stack>
        </Container>
      </Box>
    </MapControl>
  );
};

type SummaryItemProps = {
  label: string;
  value: number;
};

const SummaryItem = ({ label, value }: SummaryItemProps) => {
  return (
    <Stack direction="row" gap={{ xs: "small", sm: "medium" }} align="center">
      <Text
        tone="inverted"
        weight="semi"
        sx={{
          fontSize: {
            xs: 18,
            sm: 24,
            md: 32,
            lg: 44,
          },
        }}
      >
        {Intl.NumberFormat().format(value)}
      </Text>
      <div style={{ maxWidth: "84px" }}>
        <Text
          tone="inverted"
          weight="medium"
          sx={{
            lineHeight: 1.1,
            fontSize: {
              xs: 12,
              sm: 14,
              md: 18,
              lg: 24,
            },
          }}
        >
          {label}
        </Text>
      </div>
    </Stack>
  );
};
